import React, { useState } from "react"
import  "../AnbarGardaniStyle.css";
import * as Constants from "../../../constants/urls";

const ShortcutsModal=(props)=>{
    
    return(
        <React.Fragment>
          
<div className="location_modal text-right">
<div className="location_modal_box">
    <div className="location_modal_header bg-dark p-2">
<span className=" w-100 text-right text-white">میانبر ها </span>
    </div>
    <div className="p-4 text-center"> 
       
<div className="row text-center mt-2">
            <a className="btn btn-block btn-primary m-2" target="_blank" href={Constants.oldAdminUrl + "/productstock/admin?ProductStock%5Bproduct_id%5D="+props.props.id} >لاگ موجودی ها  </a>
  
 </div>  
 <div className="row text-center mt-2">
           <a className="btn  btn-block btn-warning m-2"  target="_blank" href={Constants.oldAdminUrl + "/products/update/"+props.props.id}>ویرایش محصول </a>
    
 </div>  
 <div className="row text-center mt-2">
       <a className="btn btn-block btn-info m-2" target="_blank" href={Constants.siteUrl + '/' + props.props.url} >نمایش محصول </a>
    
 </div>  
 

<hr />
<div className="row text-right my-3 " style={{direction:"rtl"}}>
    <div className="col-sm-12 text-sm-left">
    <button className="btn btn-block btn-danger w-100" onClick={props.close}>بستن</button>
    </div>
    
    </div>
    </div>
   

</div> 
</div> 
            </React.Fragment>
        )
}
export default ShortcutsModal;